module.exports = __webpack_public_path__ + "static/14-d5ffc570ad992b759b3d22bc00858d16.jpeg";